import { from, of } from "rxjs"
import { ofType } from "redux-observable"
import { switchMap, catchError } from "rxjs/operators"
import { push } from "connected-react-router"
import {
    fetchCarOrderSuccess,
    fetchShipperTracksSuccess,
    saveCarOrderQuanlitySuccess,
    fetchCarOrderPatternsSuccess,
} from "./actions"
import { hideLoader } from "../loader/actions"
import carOrderApi from "../../api/car-order-api"
import * as types from "./actionTypes"
import * as errorActions from "../error/actions"

export function fetchAllCarOrderData(action$) {
    return action$.pipe(
        ofType(types.CAR_ORDER_FETCH_DATA),
        switchMap((action) =>
            from(carOrderApi.getAllCarOrderData(action.payload)).pipe(
                switchMap((data) =>
                    of(fetchCarOrderSuccess(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function fetchAllCarOrderFilter(action$) {
    return action$.pipe(
        ofType(types.CAR_ORDER_FETCH_FILTER),
        switchMap((action) =>
            from(carOrderApi.getAllCarOrderData(action.payload)).pipe(
                switchMap((data) =>
                    of(fetchCarOrderSuccess(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function fetchShipperTracks(action$) {
    return action$.pipe(
        ofType(types.SHIPPER_TRACKS_FETCH_DATA),
        switchMap((action) =>
            from(carOrderApi.getShipperTracks(action.payload)).pipe(
                switchMap((data) =>
                    of(fetchShipperTracksSuccess(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function saveCarOrderQuality(action$) {
    return action$.pipe(
        ofType(types.SAVE_CAR_ORDER_QUALITY),
        switchMap((action) =>
            from(carOrderApi.saveCarOrderQuality(action.payload)).pipe(
                switchMap((dataResponse) =>
                    of(saveCarOrderQuanlitySuccess(dataResponse), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function fetchAllCarOrderPatternsData(action$) {
    return action$.pipe(
        ofType(types.CAR_ORDER_PATTERNS_FETCH_DATA),
        switchMap((action) =>
            from(carOrderApi.getAllCarOrderPatternsData(action.payload)).pipe(
                switchMap((data) =>
                    of(fetchCarOrderPatternsSuccess(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}
